export default {
  getData: (state) => state.data || {},
  getClassData: (state) => state.classData || {},
  getEditClassData: (state) => state.classDataEdit || {},
  getEditClassDataDelta: (state) => state.classDataEditDelta || {},
};
